{
  "blocks": [
    {
      "id": "proc-trigger-shot",
      "kind": "procedure",
      "tags": [
        "medications",
        "her",
        "during-cycle",
        "ivf",
        "iui",
        "egg-freezing",
        "practical"
      ],
      "title": "Trigger Shot",
      "subtitle": "Precisely timed injection for final egg maturation",
      "body": {
        "procedureName": "Trigger Shot (hCG or GnRH Agonist Trigger)",
        "category": "stimulation",
        "description": "The trigger shot is a precisely timed injection that induces the final maturation of your eggs, scheduling ovulation approximately 36 hours later. The timing is critical, it determines when egg retrieval or IUI is performed.",
        "howItWorks": "Once your monitoring shows that follicles have reached an optimal size (typically 17-22 mm for lead follicles), your care team will instruct you to administer the trigger shot at an exact time, often late in the evening. The most common triggers are hCG (Ovidrel, Pregnyl, or Novarel) or a GnRH agonist (Lupron) for patients at higher risk of ovarian hyperstimulation syndrome. Some protocols use a dual trigger combining both. The injection is given subcutaneously in the abdomen or intramuscularly in the upper buttock depending on the medication. Egg retrieval is then scheduled exactly 34-36 hours after the injection.",
        "duration": "5 minutes (injection itself)",
        "costRange": {
          "low": 50,
          "high": 350
        },
        "currency": "USD",
        "anesthesia": "none",
        "painAndComfort": [
          "The injection may sting briefly; some people notice temporary tenderness at the injection site."
        ],
        "risks": [
          "Mild stinging at the injection site",
          "Increased bloating or pelvic fullness over the next 24-36 hours",
          "Ovarian hyperstimulation syndrome (rare, more common with hCG trigger)"
        ],
        "prepInstructions": [
          "Write down the exact time your clinic assigns, even a one-hour deviation matters",
          "Set multiple alarms for 15 minutes before, 5 minutes before, and at the injection time",
          "Have your injection supplies ready and at room temperature",
          "Review the injection technique video or instructions your clinic provided",
          "If you are mixing the medication yourself (e.g., Pregnyl), prepare it 15-20 minutes early",
          "Have a partner or friend help if you are not comfortable self-injecting"
        ],
        "whatToExpect": [
          "A subcutaneous or intramuscular injection depending on the medication",
          "Mild stinging at the injection site that resolves quickly",
          "You may notice increased bloating or pelvic fullness over the next 24-36 hours",
          "Your clinic will confirm the retrieval or IUI time, usually 36 hours after the shot",
          "Do not take any additional stimulation medications after the trigger unless instructed",
          "Have your trigger medication, syringes, and alcohol swabs ready",
          "Have written instructions from your clinic with the exact time",
          "Ice pack (optional, numbing the injection site can help)"
        ],
        "forWhom": "her",
        "frBody": {
          "procedureName": "Déclencheur (trigger)",
          "description": "Le déclencheur est une injection à horaire précis qui induit la maturation finale des ovocytes et programme l'ovulation environ 36 heures plus tard. Le timing est crucial : il détermine le moment de la ponction ovocytaire ou de l'IIU (insémination intra-utérine).",
          "howItWorks": "Lorsque le monitorage montre que les follicules ont atteint une taille optimale (généralement 17 à 22 mm pour les follicules dominants), votre équipe vous indique d'administrer le déclencheur à une heure précise, souvent en fin de soirée. Les déclencheurs les plus utilisés sont l'hCG (Ovitrelle, Pregnyl ou Novarel) ou un agoniste de la GnRH (Lupron) chez les patientes à risque de SHO (syndrome d'hyperstimulation ovarienne). Certains protocoles utilisent un déclencheur dual associant les deux. L'injection est administrée en sous-cutané dans l'abdomen ou en intramusculaire dans la fesse selon le médicament. La ponction est ensuite programmée exactement 34 à 36 heures après l'injection.",
          "duration": "5 minutes (injection elle-même)",
          "risks": [
            "Léger picotement au point d'injection",
            "Augmentation des ballonnements ou sensation de plénitude pelvienne dans les 24 à 36 heures",
            "Syndrome d'hyperstimulation ovarienne (rare, plus fréquent avec un déclencheur hCG)"
          ],
          "prepInstructions": [
            "Notez l'heure exacte indiquée par votre centre : un décalage d'une heure compte",
            "Programmez plusieurs alarmes : 15 minutes, 5 minutes et à l'heure exacte",
            "Préparez votre matériel d'injection à température ambiante",
            "Revoyez la vidéo ou les instructions d'injection fournies par votre centre",
            "Si vous reconstituez le médicament vous-même (par ex. Pregnyl), préparez-le 15 à 20 minutes en avance",
            "Faites-vous aider par un proche si vous n'êtes pas à l'aise pour vous injecter seule"
          ],
          "whatToExpect": [
            "Injection sous-cutanée ou intramusculaire selon le médicament",
            "Léger picotement au point d'injection, disparaissant rapidement",
            "Possible augmentation des ballonnements ou plénitude pelvienne dans les 24 à 36 heures",
            "Votre centre confirme l'heure de la ponction ou de l'IIU, généralement 36 heures après l'injection",
            "Ne prenez plus d'autre médicament de stimulation après le déclencheur, sauf indication contraire",
            "Préparez votre déclencheur, les seringues et les compresses alcoolisées",
            "Conservez les instructions écrites de votre centre avec l'heure exacte",
            "Une poche de glace (optionnelle) peut aider à anesthésier le site"
          ]
        }
      },
      "sources": [
        {
          "title": "ESHRE guideline: ovarian stimulation for IVF/ICSI",
          "authors": "ESHRE Guideline Group on Ovarian Stimulation",
          "journal": "Human Reproduction Open",
          "year": 2020,
          "url": "https://academic.oup.com/hropen/article/2020/2/hoaa009/5826933",
          "evidenceLevel": "guideline"
        }
      ]
    }
  ],
  "relationships": [],
  "localeVariants": []
}
